// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

import { TabLoader, TabConfig, addTab, removeAll } from 'wdna-components/lib/tabs';

const Component: React.LazyExoticComponent<any> = React.lazy(() => import('../components/parameters/List'));

export default class Parameters extends TabLoader {
  /* Override tab loader method */
  public loadTab = (tabId?: string | number): void => {
    const access: boolean = true;
    if (access) {
      window.store.dispatch(removeAll());

      const tabData: TabConfig = {
        id: String(tabId || window.getStr()),
        title: 'Configuration | Parameters',
        active: true,
        component: Component,
        props: {
          report: 'CONFIGURATION_PARAMETERS',
          title: 'Parameters',
        },
      };

      window.store.dispatch(addTab(tabData));
    }
  };
}
